import { useReactiveVar } from "@apollo/client";
import { useEffect } from "react";
import { footerRefVar } from "~/components/blocks/layout/store";

import { useResizeWindow } from "~/hooks/use-resize-window";

export const useGetFooterRefResize = () => {
  const footerRef = useReactiveVar(footerRefVar);

  const { windowWidth } = useResizeWindow({
    shouldIncludedScrollBarWidth: false,
  });

  useEffect(() => {
    //NOTE: resizeした場合refを再読み込みするため
    return;
  }, [windowWidth]);

  return { footerRef };
};
